import React from 'react';

/**
 * Skeleton loading placeholder.
 *
 * Usage:
 *   <Skeleton width="100%" height={20} />
 *   <Skeleton.Card rows={4} />
 *   <Skeleton.KPIGrid count={8} />
 */
export default function Skeleton({ width = '100%', height = 16, borderRadius = 10, style: extra }) {
  return (
    <div
      className="hhms-skeleton"
      style={{ width, height, borderRadius, flexShrink: 0, ...extra }}
    />
  );
}

// ── Skeleton.Card ─────────────────────────────────────────────────────────────
Skeleton.Card = function SkeletonCard({ rows = 3 }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 16, border: '1px solid #ECE3E7', padding: '16px 20px',
      boxShadow: '0 1px 2px rgba(13,27,46,.04), 0 10px 30px -16px rgba(13,27,46,.10)',
    }}>
      <Skeleton width="40%" height={12} style={{ marginBottom: 14 }} />
      <Skeleton width="70%" height={28} style={{ marginBottom: 10 }} />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} width={`${60 + i * 10}%`} height={11} style={{ marginBottom: 7 }} />
      ))}
    </div>
  );
};

// ── Skeleton.KPIGrid ──────────────────────────────────────────────────────────
Skeleton.KPIGrid = function SkeletonKPIGrid({ count = 8, cols = 4 }) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${cols}, 1fr)`,
      gap: 14,
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{
          background: '#fff', borderRadius: 16, border: '1px solid #ECE3E7', padding: '16px 20px',
          boxShadow: '0 1px 2px rgba(13,27,46,.04), 0 10px 30px -16px rgba(13,27,46,.10)',
          borderLeft: '4px solid #edf1f5',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <Skeleton width="60%" height={10} />
            <Skeleton width={28} height={28} borderRadius={7} />
          </div>
          <Skeleton width="50%" height={26} style={{ marginBottom: 6 }} />
          <Skeleton width="40%" height={10} />
        </div>
      ))}
    </div>
  );
};

// ── Skeleton.Table ────────────────────────────────────────────────────────────
Skeleton.Table = function SkeletonTable({ rows = 6, cols = 5 }) {
  return (
    <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #ECE3E7', overflow: 'hidden', boxShadow: '0 1px 2px rgba(13,27,46,.04), 0 10px 30px -16px rgba(13,27,46,.10)' }}>
      {/* Header */}
      <div style={{
        display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: 16, padding: '12px 16px', background: '#f6eff2',
        borderBottom: '1px solid #edf1f5',
      }}>
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} width="70%" height={10} />
        ))}
      </div>
      {/* Rows */}
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} style={{
          display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`,
          gap: 16, padding: '13px 16px',
          borderBottom: r < rows - 1 ? '1px solid #f6eff2' : 'none',
        }}>
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} width={`${55 + Math.random() * 35}%`} height={11} />
          ))}
        </div>
      ))}
    </div>
  );
};
